import { Controller } from "@hotwired/stimulus"

// Inline edit: toggle entre vista (titulo + link "editar") y
// edicion (input + boton guardar + boton cancelar).
// El submit del titulo se envia via fetch PATCH con Accept: application/json
// y actualiza el DOM client-side sin recargar el frame.
//
// Soporta dos mecanismos de toggle:
// 1. Stimulus action directa: `data-action="click->manage--inline-edit#toggle"`
//    para elementos que comparten el arbol DOM con el controller.
// 2. CustomEvent en document: `inline-edit:toggle` con `detail.targetId` igual
//    al `id` del elemento raiz del controller. Necesario cuando el trigger
//    vive dentro de un dropdown que se teletransporta a <body> (caso
//    manage--dropdown con data-event="inline-edit:toggle").
export default class extends Controller {
  static targets = ["display", "edit", "input", "title", "form"]

  connect() {
    this._docHandler = (event) => {
      const detail = event.detail || {}
      if (detail.targetId && detail.targetId === this.element.id) {
        this._applyToggle()
      }
    }
    document.addEventListener("inline-edit:toggle", this._docHandler)
  }

  disconnect() {
    document.removeEventListener("inline-edit:toggle", this._docHandler)
  }

  toggle(event) {
    event.stopPropagation()
    event.preventDefault()
    this._applyToggle()
  }

  // Submit via fetch para inline edit de titulo.
  submit(event) {
    event.preventDefault()
    event.stopPropagation()

    const form = this.formTarget
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const formData = new FormData(form)

    fetch(form.action, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: formData
    }).then(resp => {
      if (resp.ok) {
        if (this.hasTitleTarget) {
          this.titleTarget.textContent = this.inputTarget.value
        }
        this.displayTarget.classList.remove("hidden")
        this.editTarget.classList.add("hidden")
        document.dispatchEvent(new CustomEvent("editor:record-saved", { bubbles: true }))
      }
    }).catch(err => console.error("[inline-edit] error:", err))
  }

  _applyToggle() {
    const editing = this.editTarget.classList.contains("hidden")
    this.displayTarget.classList.toggle("hidden", editing)
    this.editTarget.classList.toggle("hidden", !editing)
    if (editing && this.hasInputTarget) {
      this.inputTarget.focus()
      this.inputTarget.select()
    }
  }
}
